
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';


// Sentry.init({
//   dsn: "https://30693a2442f6c1393c7826a28accd7e1@o4507298248654848.ingest.us.sentry.io/4507298441134080",
//   environment: environment.env,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['https://cms.orderaxe.com'],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   enabled: !!window.location.origin.includes('orderaxe.com')
// });

if (environment.production) {
	enableProdMode();
}

/* For console nothing in production mode */
if (['prod', 'stage'].includes(environment.env)) {
	if (window) {
		window.console.log = window.console.info = () => {
			// Don't log anything.
		};
	}
}

bootstrapApplication(AppComponent, appConfig)
	.catch((err) => console.error(err));
